var symphony = symphony || {};

;
(function () {
    
    var screenWidth = window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;    

    symphony.cardsDisplay = function () {
        var cardModules = document.querySelectorAll(".cards-module");
        // loop over all
        // if it has card-using-desktop-slides class
        // then call slick

        var mobilePreview = $('.admin--icon-mobile.active')[0];
        
        if (cardModules.length > 0) {
            for (var i = 0; i < cardModules.length; i++) {
                var card = cardModules[i];

                if (!card.classList.contains("slick-initialized") && mobilePreview != undefined) {
                    if (card.classList.contains("card-using-mobile-slides")) {
                        card.classList.remove("card-using-desktop-slides");
                        $(card).slick({
                            dots: true
                        });
                    }
                } else {

                    if (!card.classList.contains("slick-initialized") && card.classList.contains("card-using-desktop-slides") && screenWidth >= 1024) {
                        card.classList.remove("card-using-mobile-slides");
                        $(card).slick({
                            dots: true
                        });
                    } else if (card.classList.contains("slick-initialized") && !card.classList.contains("card-using-desktop-slides") && screenWidth >= 1024) {

                        $(card).slick('unslick');
                    }
    
                    if (!card.classList.contains("slick-initialized") && card.classList.contains("card-using-mobile-slides") && screenWidth < 1024) {
                        card.classList.remove("card-using-desktop-slides");
                        $(card).slick({
                            dots: true
                        });
                    } else if (card.classList.contains("slick-initialized") && !card.classList.contains("card-using-mobile-slides") && screenWidth < 1024) {

                        $(card).slick('unslick');
                    }
                }
            }
        }
    };

})();
